<script module lang="ts">
  export type { ThresholdRange, ThresholdRanges } from "./thresholds"
</script>

<script lang="ts">
  import type { ComponentProps } from "svelte"
  import { getFeaturesStore } from "@/libs/feature-toggle/store.svelte"

  type CompassModule = typeof import("./IlluminationCompassV1/IlluminationCompass.svelte")

  const featuresStore = getFeaturesStore()

  let props: ComponentProps<CompassModule["default"]> = $props()
  let shouldUseV2 = $derived(
    featuresStore?.isReady && featuresStore.features.isOn("new-illumination-compass"),
  )

  let compass = $derived(
    (shouldUseV2
      ? import("./IlluminationCompassV2/IlluminationCompass.svelte")
      : import("./IlluminationCompassV1/IlluminationCompass.svelte")) as Promise<CompassModule>,
  )
</script>

{#await compass then Module}
  <Module.default {...props} />
{/await}
